module.exports = __webpack_public_path__ + "img/img_cx2_open.6c503f0d.jpg";